<template>
  <div>
    <div class="filters-banner d-flex align-items-center justify-content-between">
      <div class="filters-left d-flex align-items-center flex-nowrap" style="margin-top: 1%; overflow: hidden;">
        <b-form-datepicker v-model="startDate" class="filter-item filter-item--date mr-2" placeholder="Start Date"
          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
        <b-form-datepicker v-model="endDate" class="filter-item filter-item--date mr-2" placeholder="End Date"
          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
        <b-form-select v-model="filters.details" :options="detailsOptions" class="filter-item mr-2"
          style="width: 150px; min-width: 150px; flex-shrink: 0;" placeholder="Name" />
        <b-form-select v-model="filters.entityType" :options="typeOptions" class="filter-item mr-2"
          style="width: 150px; min-width: 150px; flex-shrink: 0;" placeholder="Type" />
        <b-form-select v-model="filters.action" :options="actionOptions" class="filter-item mr-2"
          style="width: 150px; min-width: 150px; flex-shrink: 0;" placeholder="Action" />
        <b-form-select v-model="filters.user" :options="userOptions" class="filter-item mr-2"
          style="width: 150px; min-width: 150px; flex-shrink: 0;" placeholder="User" />
        <b-form-input v-model="searchQuery" class="filter-item mr-2"
          style="width: 150px; min-width: 150px; flex-shrink: 0;" placeholder="Search..." />
        <h5 class="serviceriver-count mb-0 mr-2" style="flex-shrink: 0;">({{ filteredAuditLogs.length }})</h5>
        <b-button v-b-tooltip.hover title="Reset Filters" @click="resetFilters" variant="secondary"
          class="filter-item reset-btn" style="flex-shrink: 0;">
          Reset
        </b-button>
      </div>
    </div>

    <div class="table-container">
      <b-overlay :show="loading" rounded="sm" opacity="0.6" spinner-variant="warning">
        <b-table striped hover :items="filteredAuditLogs" :fields="fields">
          <!-- Custom cell for displaying item or tourriver name based on conditions -->
          <template #cell(details)="data">
            <span v-if="data.item && data.item.entityType === 'serviceriver'">
              {{ determineDetailValue(data.item.oldValue?.item, data.item.newValue?.item) }}
            </span>
            <span v-else-if="data.item && data.item.entityType === 'tourriver'">
              {{ determineDetailValue(data.item.oldValue?.tourName, data.item.newValue?.tourName) }}
            </span>
            <span v-else>N/A</span>
          </template>
          <template #cell(id)="data">
            <span v-if="data.item && data.item.entityType === 'serviceriver'">
              {{ determineDetailValue(data.item.oldValue?.id, data.item.newValue?.id) }}
            </span>
            <span v-else-if="data.item && data.item.entityType === 'tourriver'">
              {{ determineDetailValue(data.item.oldValue?.id, data.item.newValue?.id) }}
            </span>
            <span v-else>N/A</span>
          </template>
          <!-- Custom cell for displaying createdAt timestamp -->
          <template #cell(createdAt)="data">
            <span v-if="data.item && (data.item.entityType === 'serviceriver' || data.item.entityType === 'tourriver')">
              {{ formatDate(data.item.createdAt) }}
            </span>
            <span v-else>N/A</span>
          </template>
          <!-- Custom cell for displaying timestamp (Updated At) -->
          <template #cell(timestamp)="data">
            <span>{{ formatDate(data.item?.timestamp) }}</span>
          </template>

          <template #cell(view)="data">
            <b-button @click="showBox(data.item)" variant="link">
              <i class="fas fa-eye"></i>
            </b-button>
          </template>
          <template #cell(restore)="data">
            <b-button @click="restoreItem(data.item)" variant="link" v-if="data.item.action === 'DELETE'">
              <i class="fas fa-undo"></i>
            </b-button>
          </template>
        </b-table>
      </b-overlay>
    </div>

    <!-- Display box with old and new values -->
    <div v-if="showBoxFlag" class="box-container">
      <div class="box old-values">
        <h5>Old Values</h5>
        <pre v-for="(value, key) in boxData.oldValue" :key="key" :class="{ 'changed-red': value.changed }">
      {{ key }}: {{ value.value }}
    </pre>
      </div>
      <div class="box new-values">
        <button @click="closeBox" class="close-button">X</button>
        <h5>New Values</h5>
        <pre v-for="(value, key) in boxData.newValue" :key="key" :class="{ 'changed-green': value.changed }">
      {{ key }}: {{ value.value }}
    </pre>
      </div>
    </div>
  </div>
</template>



<style scoped>
.container {
  max-width: 100%;
}

.filters-banner {
  background-color: #f8f9fa;
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 999;
}

.filters-left {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
}

.filters-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-item {
  min-width: 140px;
  max-width: 140px;
}

.filter-item--date {
  min-width: 130px;
  max-width: 150px;
}

:deep(.filter-item--date .btn) {
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.filter-item--date label) {
  margin-bottom: 0;
  padding: 0;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
  flex: 1;
}

.search-bar {
  max-width: 300px;
}

.reset-btn {
  min-width: 100px;
}

.serviceriver-length-center {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  text-align: center;
}

.serviceriver-count {
  font-weight: bold;
}

.table-container {
  max-height: 65vh;
  overflow-y: auto;
  display: block;
  margin-top: 20px;
}

.b-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #343a40;
  color: white;
}

.b-table th {
  padding: 10px;
}

.rowgroup {
  position: sticky;
}

.b-table {
  border-collapse: collapse;
  width: 100%;
}


.box-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -20%);
  width: 1200px;
  height: 1000px;
  background: white;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
}


.box {
  width: 48%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  position: relative;
  font-size: 14px;
  height: 100%;
  overflow-y: auto;
}

.old-values {
  background-color: #f8f9fa;
}

.new-values {
  background-color: #e9ecef;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
}

.changed-red {
  color: red;
  font-weight: bold;
}

.changed-green {
  color: green;
  font-weight: bold;
}
</style>


<script>
import moment from 'moment';

export default {
  data() {
    const currentDate = moment().toDate(); // Get the current date
    const startDate = moment().subtract(5, 'days').toDate(); // Get the date 5 days before

    return {
      auditLogs: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'details', label: 'Name' },
        { key: 'entityType', label: 'Type' },
        { key: 'action', label: 'Action' },
        { key: 'createdAt', label: 'Created At' },
        { key: 'timestamp', label: 'Updated At' },
        { key: 'users_permissions_user', label: 'User', formatter: (value) => value?.data?.attributes?.email || 'N/A' },
        { key: 'view', label: 'View' },
        { key: 'restore', label: 'Restore' },
      ],
      showBoxFlag: false,
      boxData: {
        oldValue: {},
        newValue: {}
      },
      searchQuery: '',
      filters: {
        entityType: '',
        details: '',
        action: '',
        user: ''
      },
      startDate: startDate,
      endDate: currentDate,
      loading: false,
    };
  },
  async mounted() {
    await this.filterAuditLogs();
  },

  computed: {
    sortedUniqueTypes() {
      return [...new Set(this.auditLogs.map(auditLog => auditLog.entityType))].sort();
    },
    typeOptions() {
      return [{ value: '', text: 'Type' },
      ...this.sortedUniqueTypes.map(entityType => ({ value: entityType, text: entityType }))
      ];
    },
    actionOptions() {
      return [{ value: '', text: 'Action' },
      ...Array.from(new Set(this.auditLogs.map(log => log.action)))
        .map(action => ({ value: action, text: action }))
      ];
    },
    userOptions() {
      return [{ value: '', text: 'User' },
      ...Array.from(new Set(this.auditLogs.map(log => log.users_permissions_user?.data?.attributes?.email || 'N/A')))
        .map(user => ({ value: user, text: user }))
      ];
    },
    detailsOptions() {
      return [{ value: '', text: 'Name' },
      ...Array.from(new Set(this.auditLogs.map(log => {
        if (log.entityType === 'serviceriver') {
          return log.oldValue?.item || log.newValue?.item || 'N/A';
        } else if (log.entityType === 'tourriver') {
          return log.oldValue?.tourName || log.newValue?.tourName || 'N/A';
        }
        return 'N/A';
      }))).map(detail => ({ value: detail, text: detail }))
      ];
    },
    filteredAuditLogs() {
      return this.auditLogs.filter(log => {
        const matchesType = !this.filters.entityType || log.entityType === this.filters.entityType;
        const matchesAction = !this.filters.action || log.action === this.filters.action;
        const matchesUser = !this.filters.user || (log.users_permissions_user?.data?.attributes?.email === this.filters.user);
        const matchesDetails = !this.filters.details ||
          (log.entityType === 'serviceriver' && (log.oldValue?.item === this.filters.details || log.newValue?.item === this.filters.details)) ||
          (log.entityType === 'tourriver' && (log.oldValue?.tourName === this.filters.details || log.newValue?.tourName === this.filters.details));

        // Check if any field contains the search query
        const matchesSearchQuery = !this.searchQuery ||
          (log.entityType && log.entityType.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
          (log.action && log.action.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
          (log.users_permissions_user?.data?.attributes?.email && log.users_permissions_user.data.attributes.email.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
          (log.oldValue && JSON.stringify(log.oldValue).toLowerCase().includes(this.searchQuery.toLowerCase())) ||
          (log.newValue && JSON.stringify(log.newValue).toLowerCase().includes(this.searchQuery.toLowerCase()));

        return matchesType && matchesAction && matchesUser && matchesDetails && matchesSearchQuery;
      });
    }
  },
  watch: {
    startDate(newVal) {
      if (newVal && this.endDate) {
        this.filterAuditLogs();
      }
    },
    endDate(newVal) {
      if (newVal && this.startDate) {
        this.filterAuditLogs();
      }
    }
  },

  methods: {
    async restoreService(oldValue) {
      const serviceData = {
        ...oldValue,
        cities: oldValue.cities || [],
      };
      // Check if the serviceriver already exists
      const existingServiceResponse = await this.$xhr.get(`/api/servicerivers?filters[id]=${oldValue.id}`);
      if (existingServiceResponse.data.data.length > 0) {
        this.$bvToast.toast('serviceriver already exists or has been restored.', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 2000,
          solid: true
        });
        return;
      }

      const response = await this.$xhr.post('/api/servicerivers', { data: serviceData });

      if (response.status === 200) {
        this.$bvToast.toast('serviceriver restored successfully!', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 2000,
          solid: true
        });
        await this.filterAuditLogs();
      }
    },

    async restoreTour(oldValue) {
      const tourData = {
        ...oldValue,
        cities: oldValue.cities || [],
      };
      const existingTourResponse = await this.$xhr.get(`/api/tourrivers?filters[id]=${oldValue.id}`);
      if (existingTourResponse.data.data.length > 0) {
        this.$bvToast.toast('tourriver already exists or has been restored.', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 2000,
          solid: true
        });
        return;
      }

      const response = await this.$xhr.post('/api/tourrivers', { data: tourData });

      if (response.status === 200) {
        this.$bvToast.toast('tourriver restored successfully!', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 2000,
          solid: true
        });
        await this.filterAuditLogs();
      }
    }
    ,
    handleRestore(entityType, oldValue) {
      if (entityType === 'serviceriver') {
        this.restoreService(oldValue);
      } else if (entityType === 'tourriver') {
        this.restoreTour(oldValue);
      }
    },
    restoreItem(item) {
      const { entityType, oldValue } = item;
      this.handleRestore(entityType, oldValue);
    },
    async filterAuditLogs() {
      if (!this.startDate || !this.endDate) return;
      this.loading = true;
      const formattedStartDate = moment(this.startDate).format('YYYY-MM-DD');
      const formattedEndDate = moment(this.endDate).format('YYYY-MM-DD');
      const response = await this.$xhr.get(`/api/audit-logs?populate=*&filters[date][$gte]=${formattedStartDate}&filters[date][$lte]=${formattedEndDate}`);

      this.auditLogs = response.data.data.map(log => ({
        ...log.attributes,
        oldValue: log.attributes.oldValue || '{}',
        newValue: log.attributes.newValue || '{}'
      })).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      this.loading = false;
    },

    handleDateChange(newDate) {
      this.inputDate = newDate;
      this.filterAuditLogs();

    },
    determineDetailValue(oldValue, newValue) {
      if (!oldValue || oldValue === 'N/A') {
        return newValue || 'N/A';
      }
      if (!newValue || newValue === 'N/A') {
        return oldValue;
      }
      return newValue;
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(date).toLocaleDateString(undefined, options);
    },
    showBox(item) {
      const oldValue = item.oldValue || {};
      const newValue = item.newValue || {};
      const differences = this.getDifferences(oldValue, newValue);

      this.boxData.oldValue = differences.oldValue;
      this.boxData.newValue = differences.newValue;
      this.showBoxFlag = true;
    },
    getDifferences(oldValue, newValue) {
      const oldDiff = {};
      const newDiff = {};

      if (typeof oldValue !== 'object' || oldValue === null) oldValue = {};
      if (typeof newValue !== 'object' || newValue === null) newValue = {};

      Object.keys({ ...oldValue, ...newValue }).forEach(key => {
        const oldVal = oldValue[key];
        const newVal = newValue[key];

        if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
          oldDiff[key] = { value: oldVal, changed: true };
          newDiff[key] = { value: newVal, changed: true };
        } else {
          oldDiff[key] = { value: oldVal, changed: false };
          newDiff[key] = { value: newVal, changed: false };
        }
      });

      return { oldValue: oldDiff, newValue: newDiff };
    },
    closeBox() {
      this.showBoxFlag = false;
      this.boxData.oldValue = {};
      this.boxData.newValue = {};
    },
    resetFilters() {
      this.filters = {
        entityType: '',
        details: '',
        action: '',
        user: ''
      };
      this.startDate = null;
      this.endDate = null;
      this.filterAuditLogs();
    }
  }
};
</script>
